/**
 * Audit Log Component
 */

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../services/api';
import './AuditLog.css';

function AuditLog({ companyId }) {
  const { t } = useTranslation();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    rackId: '',
    actionType: '',
    limit: 100
  });

  useEffect(() => {
    fetchAuditLogs();
  }, [filters.limit, companyId]);

  const fetchAuditLogs = async () => {
    try {
      setLoading(true);
      setError(null);

      if (!companyId) {
        setLogs([]);
        setLoading(false);
        return;
      }

      const queryFilters = { limit: filters.limit, company_id: companyId };
      const data = await api.getAuditLog(queryFilters);
      setLogs(data.data || []);
    } catch (err) {
      setError(err.message);
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="spinner-border" role="status"><span className="visually-hidden">Loading...</span></div>;
  }

  return (
    <div className="audit-container">
      <h1>{t('audit.title', 'Registro de auditoría')}</h1>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <div className="table-responsive">
        <table className="table table-striped table-hover">
          <thead className="table-dark">
            <tr>
              <th>{t('audit.timestamp', 'Fecha')}</th>
              <th>{t('audit.user', 'Usuario')}</th>
              <th>{t('audit.action', 'Acción')}</th>
              <th>{t('audit.change', 'Cambio')}</th>
              <th>{t('audit.ip_address', 'IP')}</th>
            </tr>
          </thead>
          <tbody>
            {logs.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center text-muted">
                  {t('msg.no_data', 'No hay datos')}
                </td>
              </tr>
            ) : (
              logs.map((log, idx) => (
                <tr key={idx}>
                  <td data-label={t('audit.timestamp', 'Fecha')}>{new Date(log.timestamp).toLocaleString()}</td>
                  <td data-label={t('audit.user', 'Usuario')}>{log.user?.email || 'Unknown'}</td>
                  <td data-label={t('audit.action', 'Acción')}>
                    <span className="badge bg-info">{log.action_type}</span>
                  </td>
                  <td data-label={t('audit.change', 'Cambio')}>{log.change_summary}</td>
                  <td data-label={t('audit.ip_address', 'IP')} className="text-muted">{log.ip_address}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AuditLog;
